<template>
  <div id="app">
    <Nav v-if="show"></Nav>
    <div class="uilts hidden-sm-and-down" ref="uilts"></div>
    <div class="hidden-md-and-up" style="height:1rem;"></div>
    <router-view />
    <Footers ref="footer"></Footers>
    <TabBar class="hidden-md-and-up"></TabBar>
    <!-- <div class="containerbj">
      <img src="../static/bjtp.jpg" alt="">
      <div class="tips">
        <h1>官网升级 请访问新网址</h1>
        <h2><a href="http://liuyanbrew.com/">跳转</a>等待<span style="color:red">{{time}}</span>秒后进入官网</h2>
      </div>
    </div> -->
    <contact/>
  </div>
</template>

<script>
import contact from "./components/contact";//在线客服悬浮按钮组
import Nav from "./components/Nav";
import Footers from "./components/Footers";
import TabBar from './components/TabBar.vue'
import Contact from './components/contact.vue';
export default {
  name: "App",
  components: { Nav, Footers,TabBar,contact, Contact },
  data() {
    return {
      show: true,
      uilts: true,
      time:0,
    };
  },
  mounted() {
    this._minHeight()
    let THIS=this;
    THIS.time=5;
    setInterval(THIS.countDown,1000);
    // var _hmt = _hmt || [];
    // (function () {
    //   var hm = document.createElement("script");
    //   hm.src = "https://hm.baidu.com/hm.js?3b2f0a51f179531da12cae6226ebd9ef";
    //   var s = document.getElementsByTagName("script")[0];
    //   s.parentNode.insertBefore(hm, s);
    // })();

    // if (this._isMobile()) {
    //   this.$router.push("");
    //   console.log("211");
    //   var a = document.createElement("a");
    //   a.setAttribute("href", "https://examples.liuyanniangzhi.com/");
    //   a.setAttribute("target", "_blank");
    //   a.click();
    // } else {
    //   // alert("pc端");
    //   // this.$router.replace('/pc_index');
    // }

    // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280203974'%3E%3C/span%3E%3Cscript src='https://s9.cnzz.com/z_stat.php%3Fid%3D1280203974%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"))
  },
  watch: {
    'time':function(newVal,oldVal){
          if(newVal==0){
            // window.location.href="http://liuyanbrew.com/";
          }
    },
    $route(to, from) {
      //监听路由是否变化
      if (to.query.id) {
        location.reload();
      }
      if (to.name) {
        this.$router.go(0);
      }
    },
  },
  methods: {
    countDown(){
      let THIS=this;
      THIS.time--;
    },
    _minHeight(){
      let footerH=0
      this.$nextTick(()=>{
        setTimeout(()=>{
          footerH=document.querySelector('.footer').offsetHeight
          if( window.innerWidth>=992){
            let minHeight=156+footerH
            if (document.querySelector('.main-container')){document.querySelector('.main-container').style.minHeight='calc(100vh - '+minHeight+'px)'}
          }else{
            if (document.querySelector('.main-container')){document.querySelector('.main-container').style.minHeight='calc(100vh - '+footerH+'px - 2rem)'}
          }
        },50)
      });
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style>
.containerbj{
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.tips{
  position: absolute;
  right: 25%;
  top: 35%;
}
.tips h1{
 font-size: 24px;
}
.tips h2{
  margin-top: 10%;
  background: #fff;
  padding: 5% 2%;
  width: 100%;
  font-size: 16px;
}
.tips a{
  display: inline-block;
  background: #000;
  color: #fff;
  margin-right: 5%;
  padding: 2% 5%;
}
.containerbj img{
  width: 100%;
  height: 99vh;
}
.citybox .el-dropdown{color: #00383F!important;}
.el-select-dropdown{max-width: 97%!important;}

.el-loading-spinner .path{stroke: #007175;}
.el-loading-spinner .el-loading-text{color: #007175;font-weight: bold;}
.fade-enter-active,
.fade-leave-active {
  transition: 0.3s;
  transform: translateY(0%);
  z-index: 22;
}
span[id^="cnzz_stat_icon"]{display: block;height: 0;overflow: hidden;}
.icon-right-bottom{
      right: 2%!important;
}
/* 离开页面动画 */
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transition: 0.3s;
  transform: translateY(-100%);
  z-index: 22;
}
.el-form-item__label {
  color: #00383f;
}
.el-input__inner {
  border: 1px solid #00383f;
  background: unset !important;
}
.el-form-item__label {
  color: #00383f;
}
.el-input__inner::placeholder {
  text-align: center;
}
.el-input__inner {
  border: 1px solid #00383f;
}

.el-table th.el-table__cell > .cell {
  font-size: 24px;
  color: #00383f;
  font-weight: 400;
}
.el-table tr {
  background: unset !important;
}
.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #00383f !important;
  text-align: center;
}
.el-checkbox__inner {
  background: unset !important;
  border: 1px solid #00383f !important;
}
::v-deep .el-input__inner {
  border: 1px solid #00383f !important;
  background: unset;
  border-radius: unset !important;
}
.el-input-number__increase {
  border-left: 1px solid #00383f;
}
.el-input-number__decrease {
  border-right: 1px solid #00383f;
}

.el-collapse-item__header {
  background: unset;
  border: unset;
  color: #00383f !important;
  font-size: 20px;
}
.el-collapse-item__arrow {
  color: #00383f;
}
.el-collapse-item__wrap {
  background: unset;
  border-bottom: unset;
}
.el-collapse {
  border: unset;
}
.el-divider {
  background-color: rgba(0, 56, 63, 0.5);
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #00383f;
  border-color: #00383f;
  border: 1px solid #00383f !important;
  color: #fff;
}
.el-input-number__decrease,
.el-input-number__increase {
  color: #00383f;
  font-size: 18px;
  background: unset !important;
}
.el-input-number__increase {
  color: #00383f;
  font-size: 18px;
  background: unset !important;
}

.el-radio-button__inner {
  background: unset;
  color: #00383f;
  border-radius: unset;
  border: 1px solid #00383f !important;
}
.el-input__inner {
  border: 1px solid #00383f !important;
  background: unset;
}
.el-table .cell {
  color: #00383f;
}
.el-table .cell.taocan {
  color: #00383f;
}
.el-button--danger {
  background: #00383f !important;
  border-color: #00383f !important;
  border-radius: unset;
}
.el-input-number {
  width: 120px;
}
.el-table td,
.el-table th {
  text-align: center;
}
.el-table th.el-table__cell {
  border-top: 1px solid #00383f !important;
  border-bottom: 1px solid #00383f !important ;
  background-color: unset !important;
  text-align: center;
  padding: 3% 0;
}
.el-table {
  background: unset !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #00383f;
  border-color: #00383f;
}
#app {
  font-family: "SimSun";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #00383f;
}
html,
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
legend,
input,
textarea,
button,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}

/* body::-webkit-scrollbar {
  display: none;
  
} */
body {
  padding: 0 !important;
  margin: 0 !important;
  text-align: center;
  color: #00383f;
  font-size: 14px;
  font-family: "SimSun";
  font-weight: normal;
  tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -ms-tap-highlight-color: rgba(0, 0, 0, 0);
  -moz-tap-highlight-color: rgba(0, 0, 0, 0);
  -o-tap-highlight-color: rgba(0, 0, 0, 0);
}
span {
  font-family: "SimSun";
}
h1 {
  font-family: "SimSun";
}
h4{
  font-family: "SimSun";
}
li {
  list-style-type: none;
}
a {
  text-decoration: none;
  outline: none;
  -moz-outline-style: none;
  -ms-outline-style: none;
  -webkit-outline-style: none;
  -o-outline-style: none;
  color: #00383f;
  font-family: "SimSun";
  letter-spacing: 2px;
}
p {
  font-family: "SimSun";
}
.uilts {
  width: 100%;
  height: 154px;
}
/* @media (min-width:1920px){
  .main-container{
    background-size: 1920px!important;
  }
} */
.main-container {
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
  -webkit-box-shadow: 0 0 6.25rem 3.125rem rgb(0 0 0 / 20%);
  box-shadow: 0 0 6.25rem 3.125rem rgb(0 0 0 / 20%);
  background:#fff url(../static/detail.jpg) no-repeat center top/100%;
  background-attachment:fixed;
  min-height: calc(100vh - 300px);
  transition: ease-in-out .1s;
}
@media (max-width: 767px) {
  .uilts {
    width: 100%;
    height: 118px;
  }
}
@media (max-width: 922px) {
  .tips{
      position: absolute;
      left: 10%;
      width: 80%;
    }
    .tips h1{
      font-size:24px;
    }
    .tips a{
      font-size:14px;
    }

    .tips h2{
      margin-top: 10%;
      background: #fff;
      padding: 5% 0;
      font-size:14px;
    }
.tips a{
  display: inline-block;
  background: #000;
  color: #fff;
  margin-right: 5%;
  padding: 2% 5%;
}
  #newBridge{
    display: none!important;
  }
.el-input__inner{
  border-radius: unset;
}
.el-button{
border-radius: unset;
}

}
</style>



// WEBPACK FOOTER //
// src/App.vue